module.exports = __webpack_public_path__ + "img/sigma.977df404.png";